import { Tooltip } from '@systemeio/ui'
import { getTriggerBadgeTexts } from 'modules/automation-rules/triggers/utils/get-trigger-badge-texts'
import React from 'react'
import Badge from 'shared/components/badge'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { TriggerFunnelInterface } from '../../triggers/types/automation-rule-trigger-interface'

interface TriggerBadge {
  target: TriggerFunnelInterface
}

export const TriggerBadge = ({ target }: TriggerBadge) => {
  const { t } = useLocoTranslation()

  const text = getTriggerBadgeTexts(target)

  return text ? (
    <Tooltip mode={'click'} stayOnHover label={t(text.tooltipText, { id: '' })}>
      <Badge text={t(text.badgeText)} classNames={'bg-background-tertiary'} />
    </Tooltip>
  ) : (
    <></>
  )
}
